<template>
    <div v-if="definition.schema">
        <h2 class="title">{{ mode }} {{ definition.name }}</h2>
        <div
            v-for="(field, index) in linkableFields"
            :key="index"
            :style="{ width: `${field.size}%` || '100%' }"
            class="field"
        >
            <div class="label" :for="`${field.name}-${id}`">
                {{ field.label }}
            </div>
            <input type="text" :id="`${field.name}-${id}`" v-model="localData[field.name]" />
        </div>
        <h4>Form Security</h4>
        <div class="checkbox-wrapper">
            <input
                class="form-checkbox"
                type="checkbox"
                :id="`protectionEnabled-${id}`"
                v-model="localData.protectionEnabled"
            />
            <label :for="`protectionEnabled-${id}`">PIN Security</label>
        </div>
        <template v-if="localData.protectionEnabled">
            <div class="field" style="width: 25%">
                <div class="label" :for="`pin-${id}`">PIN</div>
                <input type="text" :id="`pin-${id}`" v-model="localData.pin" />
            </div>
            <div class="field" style="width: 75%">
                <div class="label" :for="`pinHint-${id}`">PIN Hint</div>
                <input type="text" :id="`pinHint-${id}`" v-model="localData.pinHint" />
            </div>
        </template>
        <div class="bottom">
            <div>
                <button class="secondary" @click="() => close()">Cancel</button>
                <div class="delete" @click="deleteContact">Delete</div>
            </div>
            <div>
                <button class="primary" @click="saveContact">Save</button>
            </div>
        </div>
    </div>
</template>
<script>
    import { strings } from '../../utils';
    import isEmail from 'validator/es/lib/isEmail';

    export default {
        name: 'AddEditContact',
        data() {
            return {
                id: strings.random(5),
                localData: {},
                mode: 'Add',
            };
        },
        props: {
            definition: {
                type: Object,
                required: true,
            },
            data: {
                type: Object,
            },
        },
        computed: {
            values() {
                return this.localData ? this.localData : {};
            },
            linkableFields() {
                return this.definition.schema.filter((field) => field.linkable);
            },
        },
        methods: {
            async deleteContact() {
                let doDelete = await this.$store.dispatch('dialog/set', {
                    type: 'confirm',
                    header: 'Delete contact?',
                    critical: true,
                    body: 'This cannot be undone.',
                });

                if (doDelete) {
                    await this.$store.dispatch('dataElements/deleteData', this.localData.id);
                    this.reloadItems();
                    this.close();
                }
            },
            async saveContact() {
                let data = { ...this.localData };

                if (!data.fname) {
                    this.$store.commit('tooltip/set', {
                        message: 'Missing First Name',
                        trigger: `#fname-${this.id}`,
                        class: 'error',
                        position: 'bottom',
                    });

                    return;
                }

                if (!data.lname) {
                    this.$store.commit('tooltip/set', {
                        message: 'Missing Last Name',
                        trigger: `#lname-${this.id}`,
                        class: 'error',
                        position: 'bottom',
                    });

                    return;
                }

                if (data.email && !isEmail(data.email)) {
                    this.$store.commit('tooltip/set', {
                        message: 'Invalid Email',
                        trigger: `#email-${this.id}`,
                        class: 'error',
                        position: 'bottom',
                    });

                    return;
                }

                if (data.protectionEnabled && !data.pin) {
                    this.$store.commit('tooltip/set', {
                        message: 'Missing PIN',
                        trigger: `#pin-${this.id}`,
                        class: 'error',
                        position: 'right',
                    });

                    return;
                }

                if (!data.protectionEnabled) {
                    data.pin = data.pinHint = '';
                }

                if (data.id) {
                    let dataId = data.id;
                    delete data.id;

                    await this.$store.dispatch('dataElements/updateData', { dataId, data });
                    this.updateLocalItem(data);
                } else {
                    await this.$store.dispatch('dataElements/insertData', { definitionId: this.definition.id, data });
                    this.reloadItems();
                }

                this.close();
            },
            async reloadItems() {
                return await this.$store.dispatch('dataElementsList/load');
            },
            updateLocalItem(data) {
                this.$store.commit('dataElementsList/updateLocalItem', { id: this.localData.id, data });
            },
            close() {
                this.$store.commit('dialog/clear');
                setTimeout(() => {
                    this.localData = {};
                }, 300);
            },
        },
        mounted() {
            this.localData = { ...this.data };
            this.mode = Object.keys(this.data).length ? 'Edit' : 'Add';
        },
    };
</script>
<style lang="scss" scoped>
    .title {
        margin-top: 0;
    }
    .field {
        display: inline-block;
        padding: 0.5em;

        input {
            width: 100%;
        }
    }

    .bottom {
        display: flex;
        justify-content: space-between;
        padding: 1em 0.5em 0;

        > div {
            display: flex;
            align-items: center;
        }

        .delete {
            @extend a;
            margin-left: 1em;
        }
    }
</style>